import { isNullish } from "@orh/utils";
import { BrowserStorageAdapter } from "../helpers/browser-storage-adapter";
import { BrowserStorageAdapterCompressed } from "../helpers/browser-storage-adapter-compressed";
import { useKvStorage } from "./useKvStorage";
export type { Setter } from "./useKvStorage";

const storageAdapter = new BrowserStorageAdapter(() => [window.localStorage]);
const useLocalStorage = useKvStorage(storageAdapter);

const storageAdapterCompressed = new BrowserStorageAdapterCompressed(() => [window.localStorage]);
const useLocalStorageCompressed = useKvStorage(storageAdapterCompressed);

/** Reads a value that useLocalStorage saved, outside of a component. It uses the same storage and format. */
const readLocalStorage = <T>(key: string, fallback: T): T => {
  const value = storageAdapter.getSnapshot(key);
  if (isNullish(value)) return fallback;
  try {
    return JSON.parse(value) as T;
  } catch {
    return fallback;
  }
};

export { readLocalStorage, useLocalStorage, useLocalStorageCompressed };
export default useLocalStorage;
